<template>
  <SearchForm id="search" />
  <div class="py-4" />
  <AboutText />
  <FAQSection />
  <TravelDestinationsDisplay />
</template>

<script setup lang="ts">
useHead({
  title: 'Suche',
  meta: [
    {
      name: 'description',
      content:
        'Rankingsystem für Zugverbindungen nach ihrer Anschlusssicherheit basierend auf Machine Learning'
    }
  ]
})
</script>
